import React from "react";

import ViewAppBar from "../views/ViewAppBar";

import styled from "styled-components";

import ViewFooter from "../views/ViewFooter";

import ViewGerenciarTrocas from "../views/ViewGerenciarTrocas";
import { usePermissao } from "../uteis/permissaoAdm/usePermissao";

const ContainerComponente = styled.div`
  display: grid;
  grid-template: 100px 75vh 90rem 170rem 20rem / 100vw;
  @media (min-width: 1100px) {
    grid-template: 100px 100vh 20rem / 100vw;
  }
`;

const GerenciarTrocas: React.FC = () => {
  const { isLoading, isValid } = usePermissao("OPE");
   
     if (isLoading) return <p>Verificando permissão...</p>;
     if (!isValid) return null;
    return (
  <ContainerComponente>
    <ViewAppBar />
    <ViewGerenciarTrocas />
    <ViewFooter />
  </ContainerComponente>
)};
export default GerenciarTrocas;
